import React, { useState } from 'react';
import './App.css';

function App() {
  const [oyunAdi, setOyunAdi] = useState('');
  const [mrGambId, setMrGambId] = useState('');
  const [username, setUsername] = useState('');
  const [communityUsername, setCommunityUsername] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle' | 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  const endpoint = 'https://script.google.com/macros/s/AKfycbzvdp-uC2EEnFqiJSh3A6RDO1SZYOEP1zgMoN-GK2V3azeFh2Hq-vCGeRJ-Ygri0zh_/exec'; // Google Apps Script'ten aldığınız yeni URL'yi buraya yapıştırın

  function validate() {
    if (!oyunAdi.trim() || !mrGambId.trim() || !username.trim() || !communityUsername.trim()) {
      return 'Lütfen tüm alanları doldurun.';
    }
    return null;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const error = validate();
    if (error) {
      setStatus('error');
      setMessage(error);
      return;
    }

    setStatus('loading');
    setMessage('');

    // IP adresini al (opsiyonel)
    let ipAddress = 'Bilinmiyor';
    try {
      const ipResponse = await fetch('https://api.ipify.org?format=json');
      const ipData = await ipResponse.json();
      ipAddress = ipData.ip;
    } catch (ipError) {
      console.warn('IP adresi alınamadı:', ipError);
    }

    // Simple request: URLSearchParams ile form-encoded gönder
    const params = new URLSearchParams({
      oyunAdi: oyunAdi.trim(),
      mrGambId: mrGambId.trim(),
      username: username.trim(),
      communityUsername: communityUsername.trim(),
      userAgent: navigator.userAgent,
      ipAddress,
      ts: new Date().toISOString(),
    });

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        body: params, // headers eklemeyin; content-type otomatik ayarlanır
      });

      if (res.ok) {
        setStatus('success');
        setMessage("Başarıyla kaydedildi! MrGamb Community.");
        setOyunAdi('');
        setMrGambId('');
        setUsername('');
        setCommunityUsername('');
      } else {
        throw new Error('Sunucu hatası');
      }
    } catch (err) {
      console.error(err);
      setStatus('error');
      setMessage('Kayıt sırasında bir hata oluştu. Lütfen tekrar deneyin.');
    }
  }

  return (
    <div className="App">
      <div className="container">
        <div className="form-container">
          <img src="/com.png" alt="MrGamb" className="header-logo" />
          <h1>MrGamb Community Kayıt Formu</h1>
          <form onSubmit={handleSubmit} className="registration-form">
            <div className="form-group">
              <label htmlFor="oyunAdi">Oyun Adı:</label>
              <input
                type="text"
                id="oyunAdi"
                value={oyunAdi}
                onChange={(e) => setOyunAdi(e.target.value)}
                required
                placeholder="Oyun Adını Girin"
              />
            </div>

            <div className="form-group">
              <label htmlFor="mrGambId">MrGamb ID:</label>
              <input
                type="text"
                id="mrGambId"
                value={mrGambId}
                onChange={(e) => setMrGambId(e.target.value)}
                required
                placeholder="MrGamb ID'nizi girin"
              />
            </div>

            <div className="form-group">
              <label htmlFor="username">Username:</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                placeholder="Kullanıcı Adınızı Girin"
              />
            </div>

            <div className="form-group">
              <label htmlFor="communityUsername">Community Username:</label>
              <input
                type="text"
                id="communityUsername"
                value={communityUsername}
                onChange={(e) => setCommunityUsername(e.target.value)}
                required
                placeholder="Community Kullanıcı Adınızı Girin"
              /> 
            </div>

            <button type="submit" disabled={status === 'loading'} className="submit-btn">
              {status === 'loading' ? 'Kaydediliyor...' : 'Kaydet'}
            </button>
          </form>

          {status !== 'idle' && (
            <div className={`message ${status}`}>
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
